import { gql } from '@apollo/client';

export const REPORT_DELETED = gql`
  subscription reportDeleted {
    reportDeleted {
      reportId
    }
  }
`;
